import { getSupportedDevicesSync } from "@eweadn-qiankun/shared-utils";
import { ensureCrossBrandBootstrap } from "@/crossBrandHub/store/bootstrapStore";
import { runCrossBrandScan } from "@/crossBrandHub/runScan";
import { shouldExpandHidPickerToAllBrands } from "@/crossBrandHub/utils/hidPickerScope";

/** 桌面端 HID 白名单就绪：首页应再扫已授权设备（首轮常早于授权） */
export const DESKTOP_HID_WHITELIST_READY_EVENT =
  "eweadn:desktop-hid-whitelist-ready";

/** 将 supportedDevices 同步给桌面端主进程（默认品牌 Hub 异品牌开启时含全品牌 VID/PID） */
export function registerDesktopBrandHidDevices(): boolean {
  const bridge = (
    window as { electronBridge?: { sendToElectron?: (msg: unknown) => void } }
  ).electronBridge;
  if (!bridge?.sendToElectron) {
    return false;
  }
  try {
    const includeCrossBrandHid = shouldExpandHidPickerToAllBrands();
    bridge.sendToElectron({
      type: "register-brand-hid-devices",
      data: {
        devices: getSupportedDevicesSync(),
        includeCrossBrandHid,
      },
    });
    return true;
  } catch (e) {
    console.warn("[DesktopBrandHid] 上报设备表失败:", e);
    return false;
  }
}

async function registerAfterBootstrap(): Promise<void> {
  await ensureCrossBrandBootstrap(true);
  registerDesktopBrandHidDevices();
}

/** 监听桌面端 request / 白名单 ack，补发设备表并在就绪后扫描异品牌 */
export function installDesktopBrandHidDevicesListener(): () => void {
  const bridge = (
    window as {
      electronBridge?: {
        onElectronMessage?: (
          cb: (type: string, data: unknown) => void
        ) => () => void;
      };
    }
  ).electronBridge;
  if (!bridge?.onElectronMessage) {
    return () => {};
  }
  return bridge.onElectronMessage((type, data) => {
    if (type === "request-brand-hid-devices") {
      void registerAfterBootstrap();
      return;
    }
    if (type === "register-brand-hid-devices-ack") {
      const payload = data as { ok?: boolean; count?: number } | undefined;
      if (payload?.ok) {
        void runCrossBrandScan("startup");
        // 白名单就绪后通知首页再扫：否则华奋达 2.4G 首轮 getDevices 为空会永久漏卡
        try {
          window.dispatchEvent(
            new CustomEvent(DESKTOP_HID_WHITELIST_READY_EVENT)
          );
        } catch (e) {
          console.warn("[DesktopBrandHid] 派发白名单就绪事件失败:", e);
        }
      }
    }
  });
}
